<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-offline-banner></app-offline-banner>

  <!-- Blur overlay when app is backgrounded -->
  @if (appLockService.showBlur() && !appLockService.isLocked() && authStore.isAuthenticated()) {
    <div class="blur-overlay"></div>
  }

  <!-- Lock screen overlay — only for authenticated users with PIN configured -->
  @if (appLockService.isLocked() && authStore.isAuthenticated() && authStore.pinConfigured()) {
    <div class="lock-overlay">
      <app-pin-entry (unlocked)="onUnlocked()" (forgotPin)="onForgotPin()"></app-pin-entry>
    </div>
  }
</ion-app>
